module.exports = __webpack_public_path__ + "static/img/beta_bg_white_12.3443d28b.svg";